<script lang="ts">
  // Component imports
  import Card from '$lib/components/Card.svelte';
  import UsaHeatmapPro from '$lib/components/Maps/UsaHeatmapPro.svelte';
  import SankeyChartAnimated from '$lib/components/Basics/SankeyChartAnimated.svelte';
  export let data;
</script>

<div class="flex justify-center p-4">
  <div class="flex flex-col justify-center mx-auto gap-6">
    <Card href="/pro/us-heatmap" title="USA Unemployment Heatmap">
      <svelte:fragment slot="chart">
        <div class="flex items-center justify-center">
          <UsaHeatmapPro
            countyData={data.countyData}
            statesData={data.statesData}
            animateOnMount={true} />
        </div>
      </svelte:fragment>
      Interactive choropleth map showing unemployment rates across the United States.
    </Card>

    <Card href="/pro/sankey-chart" title="Energy Flow Diagram">
      <svelte:fragment slot="chart">
        <div class="flex items-center justify-center">
          <SankeyChartAnimated />
        </div>
      </svelte:fragment>
      Animated Sankey diagram showing energy flow between different sources and targets.
    </Card>
  </div>
</div>
